
import O1HD, { modules } from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import PageBase from "../../../../engines/modules/uiModule/PageBase";
import { OilFieldBuyPrams, OilFieldOverPrams } from "../../../../engines/modules/uiModule/UIPrams";
import { PLATFORM_CODE } from "../../../../engines/services/ossService";
import ModelDialogLayer from "../../../gameCommon/basic/ModelDialogLayer";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import { getOilfieldConfig, getOilfieldConfigH5, getOilfieldKengConfig, getOilfieldSpecialConfig, oilfieldInfoType, oilPrefabPATH, SpecialPrefabPATH } from "./config/oilfieldConfig";

const { ccclass, property } = cc._decorator;

@ccclass
export default class oilfieldMinePage extends cc.Component {
    mask: cc.Mask = null;
    @property({ type: cc.Node, displayName: "遮罩" })
    maskNode: cc.Node = null;
    @property({ type: cc.Node, displayName: "触碰节点" })
    touchNode: cc.Node = null;
    @property({ type: cc.Node, displayName: "游戏节点" })
    node_game: cc.Node = null
    @property({ type: cc.Node, displayName: "特殊物品节点" })
    node_itemGroup: cc.Node = null
    @property({ type: cc.Node, displayName: "油坑节点" })
    node_oilPos: cc.Node = null
    @property({ type: cc.Node, displayName: "格子节点" })
    node_PointGroup: cc.Node = null
    @property({ type: cc.SpriteFrame, displayName: "默认图片" })
    default_sprite: cc.SpriteFrame = null
    @property({ type: sp.Skeleton, displayName: "爆走特效" })
    sp_boom: sp.Skeleton = null
    @property({ type: cc.Node, displayName: "提示节点" })
    node_Tips: cc.Node = null
    oilfieldInfo: oilfieldInfoType = null;

    nowOilfieldID: number = null;
    nowOilfieldNode: cc.Node = null;
    specialIDList: number[] = []
    start() {
        this.sp_boom.node.active = false;
        this.node_Tips.active = true;
        this.mask = this.maskNode.getComponent(cc.Mask);
        this.node.on(cc.Node.EventType.TOUCH_START, this.commonFunc, this);
        this.touchNode.on(cc.Node.EventType.TOUCH_MOVE, this.commonFunc, this);
        this.touchNode.on(cc.Node.EventType.TOUCH_END, this.touchEnd, this);
        this.touchNode.on(cc.Node.EventType.TOUCH_CANCEL, this.touchEnd, this);
    }
    cantouch: boolean = false;

    allPoints: { [id: number]: { id: number, pos: cc.Vec2, isTouch: boolean } } = {};
    oilPointIDList: number[] = [];
    specialItemObj: { [id: number]: { id: number, hasIDList: number[], isOpen: boolean, node: cc.Node } } = {}
    pointlen = 80
    async init(id: number) {
        let OilFieldConifg = getOilfieldConfig;
        if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
            OilFieldConifg = getOilfieldConfigH5;
        }
        
        this.oilfieldInfo = OilFieldConifg[id];
        if (this.oilfieldInfo == null) {
            console.error("没数据？", this.oilfieldInfo, id)
            return;
        }
        {
            // 设立所有的点
            let startPos = cc.v2(-this.node_game.width / 2, this.node_game.height / 2);
            let maxWidthLen = Math.ceil(this.node_game.width / this.pointlen)
            let maxHeightLen = Math.ceil(this.node_game.height / this.pointlen)
            let index = 0;
            for (let i = 0; i < maxHeightLen; i++) {
                for (let j = 0; j < maxWidthLen; j++) {
                    let pos = cc.v2(startPos.x + j * this.pointlen + this.pointlen / 2, startPos.y - i * this.pointlen - this.pointlen / 2)
                    this.allPoints[index] = {
                        id: index,
                        pos: pos,
                        isTouch: false
                    }
                    // let node = new cc.Node();
                    // node.parent = this.node_PointGroup;
                    // node.setPosition(pos)
                    // node.addComponent(cc.Sprite).spriteFrame = this.default_sprite;
                    // let lab = new cc.Node().addComponent(cc.Label)
                    // lab.string = index + ""
                    // lab.node.setParent(node);
                    // lab.node.color = cc.Color.BLACK;
                    // lab.fontSize = 10
                    // lab.lineHeight = 10
                    // lab.node.setPosition(cc.v2(0,0))
                    // lab.verticalAlign = cc.Label.VerticalAlign.CENTER
                    // lab.horizontalAlign = cc.Label.HorizontalAlign.CENTER
                    // node.width = node.height = this.pointlen - this.pointlen * 0.1

                    index++;
                }
            }

            this.refreshPointShow();
        }
        // 选一个油矿放一个
        {
            let oilfieldIndex: number = data_control.getRandIPosByWeights(this.oilfieldInfo.hasOildielKengWeightIDList);
            let oilID = this.oilfieldInfo.hasOildielKengIDList[oilfieldIndex]

            this.nowOilfieldID = oilID;

            let oilInfo = getOilfieldKengConfig[oilID];
            if (oilInfo.showPrefabWeightList.length > 0) {
                let pathIndex = data_control.getRandIPosByWeights(oilInfo.showPrefabWeightList)
                let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.oilfield, oilPrefabPATH + oilInfo.showPrefabPathList[pathIndex], false);
                this.nowOilfieldNode = cc.instantiate(prefab);
                this.nowOilfieldNode.parent = this.node_oilPos;
                this.nowOilfieldNode.setPosition(cc.v2(0, 0));

                this.scheduleOnce(() => {

                    let boxPoints = this.nowOilfieldNode.getComponent(cc.PolygonCollider).world.points;
                    for (const key in this.allPoints) {
                        if (Object.prototype.hasOwnProperty.call(this.allPoints, key)) {
                            const element = this.allPoints[key];
                            if (cc.Intersection.pointInPolygon(this.node_PointGroup.convertToWorldSpaceAR(element.pos), boxPoints)) {
                                // 在包围框内
                                if (!this.oilPointIDList.includes(element.id)) this.oilPointIDList.push(element.id);
                            }
                        }
                    }
                    // this.cantouch = true;
                })
            }
        }

        {
            // 选择特殊事件
            this.specialIDList = [];
            let posList: cc.Vec2[] = [cc.v2(-330, 260), cc.v2(330, 260), cc.v2(-330, 0), cc.v2(330, 0), cc.v2(-330, -260), cc.v2(330, -260)].sort((a, b) => { return Math.random() - 0.5 })
            for (let i = 0, len = this.oilfieldInfo.hasOilfieldSpecialList.length; i < len; i++) {
                let id = this.oilfieldInfo.hasOilfieldSpecialList[i];
                let weight = this.oilfieldInfo.hasOilfieldSpecialWeightList[i];
                if (id == null || weight == null) continue;
                if (posList.length <= 0) continue;
                if (Math.random() < weight) {
                    this.specialIDList.push(id)

                    let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.oilfield, SpecialPrefabPATH + getOilfieldSpecialConfig[id].prefabPath, false);
                    let node = cc.instantiate(prefab);
                    node.setParent(this.node_oilPos)
                    // if (id == 0) {
                    //     node.setPosition(0, 0)
                    // } else {
                    let index = Math.floor(data_control.getRandNumberOfArrayTwo([0, posList.length]))
                    node.setPosition(posList[index]);
                    posList.splice(index, 1);
                    // }
                    node.targetOff(this);
                    node.on(cc.Node.EventType.TOUCH_START, () => {
                        node.scale = 1.1;
                    }, this)
                    node.on(cc.Node.EventType.TOUCH_CANCEL, () => {
                        node.scale = 1;
                    }, this)
                    node.on(cc.Node.EventType.TOUCH_END, this.specialTouchEnd.bind(this, id, node))

                    this.scheduleOnce(() => {

                        let boxPoints = node.getComponent(cc.PolygonCollider).world.points;
                        for (const key in this.allPoints) {
                            if (Object.prototype.hasOwnProperty.call(this.allPoints, key)) {
                                const element = this.allPoints[key];
                                if (cc.Intersection.pointInPolygon(this.node_PointGroup.convertToWorldSpaceAR(element.pos), boxPoints)) {
                                    // 在包围框内
                                    if (this.specialItemObj[id] == null) this.specialItemObj[id] = { id: id, hasIDList: [], isOpen: false, node: node }
                                    this.specialItemObj[id].hasIDList.push(element.id)
                                }
                            }
                        }
                    })
                }
            }
            console.log("特殊事件ID", this.specialIDList)
        }
        this.cantouch = true;

    }
    async specialTouchEnd(id: number, node: cc.Node, a2) {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        // if (this.over) return;
        node.scale = 1;
        node.active = false;
        if (this.specialIDList.includes(id)) this.specialIDList.splice(this.specialIDList.indexOf(id), 1)
        let func = async () => {
            let info = getOilfieldSpecialConfig[id];
            if (!info) return;
            if (utilsModel.isValidNumberValue(info.goodsId)) {
                utilsView.openPopupLayer(
                    'prefab/OilFieldGetGoodsLayer'
                    , BUNDLE_SMALL_NAME.oilfield
                    , null
                    , {
                        id: info.goodsId
                    }
                );
                return;
            }


            let page: PageBase;
            let prams: OilFieldBuyPrams = {
                id: id,
                callBack: async () => {
                    // 开采了
                    if (id == 0) {
                    }
                }
            }
            page = await modules().uiControlModule.OpenPage("prefab/oilSpecialItemPage", UI_Z_INDEX.DIALOG, prams, getOneBundleByInstant(BUNDLE_SMALL_NAME.oilfield), true);

            // // 获得与扣除钱
            // if (info.getMoney != null) {
            //     O1HD.getServices().userSrv.setCoins(info.getMoney, true, this.node);
            // }
        }

        if (id == 0) {
            this.sp_boom.node.active = true;

            this.sp_boom.animation = null;
            this.sp_boom.loop = false;
            this.sp_boom.animation = "animation";
            this.sp_boom.setToSetupPose();

            this.sp_boom.setCompleteListener(() => {
                this.sp_boom.clearTracks()
                this.sp_boom.setCompleteListener(null)
                this.sp_boom.animation = null;
                this.sp_boom.node.active = false;
                func();

                this.maskNode.active = false;
                this.touchNode.active = false;
                this.node_itemGroup.active = false;
                this.node_oilPos.active = false;

                this.over = true;
            })
        } else {
            func();
        }
    }
    async onClickBack() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        if (!this.over) {

            ModelDialogLayer.show('当前油田还没有完全探索完，\n退出后将无法继续本次探索，\n是否退出？'
            , ()=> {
                this.node && this.node.isValid && this.node.destroy();
            }, ()=> {
            }
            , '留 下'
            , '退 出'
            );
        } else
            this.node && this.node.isValid && this.node.destroy();
    }

    touchEnd() {
        if (!this.cantouch) return
        if (this.over) return;
        this.tempDrawPoints = [];
        // this.calcProgress();
    }
    commonFunc(event: cc.Event.EventTouch) {
        if (this.node_Tips.active) this.node_Tips.active = false;
        if (!this.cantouch) return
        if (this.over) return;
        this.clearMask(this.maskNode.convertToNodeSpaceAR(event.getLocation()))
        // if (event.getTouches().length <= 1) {
        //     console.error("单点")

        //     // console.error(distance)
        //     let distance = Math.abs(Math.floor(event.getLocation().sub(event.getPreviousLocation()).mag()));
        //     // console.error(distance)
        //     if (distance > 24) {
        //         //补点操作
        //         for (let num = 0; num < distance; num += 3) {
        //             let subLocation: cc.Vec2 = event.getLocation().sub(event.getPreviousLocation());
        //             let actualLocation = event.getPreviousLocation().add(subLocation.div(distance).mul(num));
        //             this._addCircle(this.maskNode.convertToNodeSpaceAR(actualLocation));
        //         }
        //     }
        //     this._addCircle(this.maskNode.convertToNodeSpaceAR(event.getLocation()));
        // } else {
        //     let firstTouch: cc.Event.EventTouch = event.getTouches()[0];
        //     let secondTouch: cc.Event.EventTouch = event.getTouches()[1];

        //     this._addLine(firstTouch, secondTouch)
        // }
    }
    over: boolean = false;

    async checkTouchPoint(pos: cc.Vec2) {
        if (this.over) return;
        let openPointLen = 0;
        let maxPointLen = 0
        for (const key in this.allPoints) {
            if (Object.prototype.hasOwnProperty.call(this.allPoints, key)) {
                maxPointLen++;
                let element = this.allPoints[key];
                if (element.isTouch) {
                    openPointLen++;
                    continue;
                }
                if (element.pos.sub(pos).mag() < this.CLEAR_LINE_WIDTH / 2) {
                    element.isTouch = true;
                    openPointLen++;
                }
            }
        }
        this.refreshPointShow()

        // 油田所包含的点被揭开了多少
        let openOilPointLen = 0;
        for (let id of this.oilPointIDList) {
            if (this.allPoints[id].isTouch) openOilPointLen++;
        }
        // console.error("油田范围：", openOilPointLen / this.oilPointIDList.length)

        // 所有的点被揭开了多少

        // console.error("所有范围：", openPointLen / maxPointLen)

        // 特殊物品揭开
        for (const key in this.specialItemObj) {
            if (Object.prototype.hasOwnProperty.call(this.specialItemObj, key)) {
                let element = this.specialItemObj[key];
                if (element.isOpen) continue;
                let open = true;
                for (let id of element.hasIDList) {
                    if (!this.allPoints[id].isTouch) {
                        open = false;
                        break;
                    }
                }
                element.isOpen = open;
                if (open) element.node.parent = this.node_itemGroup;
            }
        }

        if (openPointLen / maxPointLen > 0.8) {
            // 超过90%部分了
            this.over = true;
            let page: PageBase;
            let prams: OilFieldOverPrams = {
                id: this.nowOilfieldID,
                buyPrice: this.oilfieldInfo.buyPrice,
                spriteFrams: this.nowOilfieldNode ? this.nowOilfieldNode.getComponent(cc.Sprite).spriteFrame : null,
                callBack: async () => {
                    // this.onClickBack();
                }
            }
            page = await modules().uiControlModule.OpenPage("prefab/oilMineOverPage", UI_Z_INDEX.DIALOG, prams, getOneBundleByInstant(BUNDLE_SMALL_NAME.oilfield), true);
            let info = getOilfieldKengConfig[this.nowOilfieldID]
            if (info.getMoney != null) {
                O1HD.getServices().userSrv.setCoins(info.getMoney, true, this.node);
            }

            this.maskNode.active = false;
            this.touchNode.active = false;
        }
    }
    index: number = 0;
    tempDrawPoints: cc.Vec2[] = [];
    readonly CLEAR_LINE_WIDTH = 80;
    clearMask(pos) {
        let mask: any = this.maskNode.getComponent(cc.Mask);
        let stencil = mask._graphics;
        const len = this.tempDrawPoints.length;
        this.tempDrawPoints.push(pos);

        if (len <= 1) {
            // 只有一个点，用圆来清除涂层
            stencil.moveTo(pos.x, pos.y);
            stencil.circle(pos.x, pos.y, this.CLEAR_LINE_WIDTH / 2);
            stencil.fill();

            this.checkTouchPoint(pos);
        } else {
            // 存在多个点，用线段来清除涂层
            let prevPos = this.tempDrawPoints[len - 2];
            let curPos = this.tempDrawPoints[len - 1];

            stencil.moveTo(prevPos.x, prevPos.y);
            stencil.lineTo(curPos.x, curPos.y);
            stencil.lineWidth = this.CLEAR_LINE_WIDTH;
            stencil.lineCap = cc.Graphics.LineCap.ROUND;
            stencil.lineJoin = cc.Graphics.LineJoin.ROUND;
            stencil.strokeColor = cc.color(255, 255, 255, 255);
            stencil.stroke();

            // 记录线段经过的格子
            let distance = Math.abs(Math.floor(curPos.sub(prevPos).mag()));
            for (let num = 0; num < distance; num += this.CLEAR_LINE_WIDTH) {
                let subLocation: cc.Vec2 = curPos.sub(prevPos);
                let actualLocation = prevPos.add(subLocation.div(distance).mul(num));
                this.checkTouchPoint(actualLocation);
            }
        }
    }
    // _addCircle(point1: cc.Vec2) {


    //     let graphics: cc.Graphics = this.mask._graphics;
    //     graphics.moveTo(point1.x, point1.y)
    //     graphics.circle(point1.x, point1.y, 24);
    //     graphics.lineWidth = 20;
    //     graphics.fill();
    //     graphics.stroke();
    //     this.checkTouchPoint(point1);
    // }
    // LPoint1: cc.Vec2 = null;
    // LPoint2: cc.Vec2 = null;
    // _addLine(point1: cc.Event.EventTouch, point2: cc.Event.EventTouch) {
    //     let nowPoint1 = this.maskNode.convertToNodeSpaceAR(point1.getLocation())
    //     let nowPoint2 = this.maskNode.convertToNodeSpaceAR(point2.getLocation())

    //     let graphics: cc.Graphics = this.mask._graphics;

    //     graphics.moveTo(nowPoint1.x, nowPoint1.y);
    //     graphics.lineTo(nowPoint2.x, nowPoint2.y);
    //     graphics.lineWidth = 48;
    //     graphics.lineCap = cc.Graphics.LineCap.ROUND;
    //     graphics.lineJoin = cc.Graphics.LineJoin.ROUND;
    //     graphics.strokeColor = cc.color(255, 255, 255, 255);
    //     graphics.stroke();


    //     let distance = Math.abs(Math.floor(nowPoint1.sub(nowPoint2).mag()));
    //     for (let num = 0; num < distance; num += 3) {
    //         let subLocation: cc.Vec2 = nowPoint1.sub(nowPoint2);
    //         let actualLocation = nowPoint2.add(subLocation.div(distance).mul(num));
    //         this.checkTouchPoint(actualLocation);
    //     }
    // }


    refreshPointShow() {
        for (const key in this.allPoints) {
            if (Object.prototype.hasOwnProperty.call(this.allPoints, key)) {
                const element = this.allPoints[key];
                if (this.node_PointGroup.children[element.id]) this.node_PointGroup.children[element.id].color = element.isTouch ? cc.Color.RED : cc.Color.WHITE;

            }
        }
    }
}